import { Icon } from "helpers/icons";
import React from "react";
import ConvertStringToHtml from "../ConvertStringToHtml";

export default function ActionDialog({
  showModal,
  headerTitle,
  setShowModal,
  title,
  titleContCls = false,
  onCancelHandler,
  onConfirmHandler,
  cancelButtonText,
  confirmButtonText,
  modalSize,
  ...props
}) {
  return (
    <>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[85] outline-none focus:outline-none " >
            <div className={`relative  my-6 mx-auto ${modalSize == "md" ? "max-w-[800px]" : "max-w-[600px]"}`}>
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className={`flex items-center justify-between border-b border-solid border-slate-200 rounded-t py-2 px-5 font-normal text-sm`}>
                  <h3 className="text-2xl font-semibold text-c-black-600">
                    {headerTitle ? headerTitle : "Confirmation"}
                  </h3>

                  <button
                    className="p-1 ml-auto border-0 text-c-black-600 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                   <Icon type="cross" size="5"/>

                  </button>
                </div>
                {/*body*/}
                <div className="relative px-6 py-2 flex-auto">
                  <p className={`my-4 text-slate-500 text-lg leading-relaxed ${titleContCls ? titleContCls: ''}`}>
                    {title ? (<ConvertStringToHtml msg={title} />) : "Are you sure to perform this action!"}
                  </p>
                  {props?.children}
                </div>
                {/*footer*/}
                <div className={`flex items-center justify-end border-t border-solid border-slate-200 rounded-b text-slate-500 leading-relaxed my-1 px-2 py-1 text-lg`}>
                  <button
                    className="text-red-400 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={onCancelHandler}
                  >
                    {cancelButtonText ? cancelButtonText : "Cancel"}
                  </button>
                 {onConfirmHandler&& <button
                    className="bg-teal1000 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={onConfirmHandler}
                  >
                    {confirmButtonText ? confirmButtonText : "OK"}
                  </button>}
                  {props?.extraButton?.filter(x => !!x)?.length>0 && props?.extraButton?.map((v,k)=>(
                       <button
                       className={`${v?.btnClr}  font-bold uppercase text-sm px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
                       type="button"
                       onClick={()=>v?.callBackFun(setShowModal)}
                     >
                       {v?.text ? v?.text : "OK"}
                     </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-60 fixed inset-0 z-[75] bg-black"></div>
        </>
      ) : null}
    </>
  );
}
